import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import Footer from '../../components/Footer';

const APP_STORE_URL = 'https://apps.apple.com/us/app/tipsyou/id6727011383';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=humanX.Hatchi.TipsYou3';

function InvitePage() {
  const { t } = useTranslation();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      window.location.href = APP_STORE_URL;
      return;
    }

    if (/android/i.test(userAgent)) {
      window.location.href = PLAY_STORE_URL;
      return;
    }
  }, []);

  return (
    <div className="relative no-scroll min-h-screen bg-modern text-black flex flex-col justify-between overflow-hidden">
      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-sm text-center"
        >
          {/* Logo */}
          <div className="w-20 h-20 mx-auto mb-6 rounded-2xl overflow-hidden shadow-lg">
            <img
              src="/logo.png"
              alt="TipsYou"
              className="w-full h-full object-cover"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>

          {/* Titre */}
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {t('downloadTipsYou', 'Téléchargez TipsYou')}
          </h1>
          <p className="text-gray-500 text-sm mb-8 leading-relaxed">
            {t('downloadDescription', 'Recevez vos pourboires par carte. 100% gratuit. Prêt en 2 minutes.')}
          </p>

          {/* App Store */}
          <motion.a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center justify-center gap-3 w-full bg-black text-white py-3.5 px-6 rounded-2xl text-sm font-semibold mb-3 no-underline"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            App Store
          </motion.a>

          {/* Google Play */}
          <motion.a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center justify-center gap-3 w-full bg-gray-100 text-gray-900 py-3.5 px-6 rounded-2xl text-sm font-semibold mb-6 no-underline"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#34a853">
              <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302L22.302 13 20 11.508l-2.302-1.999zM5.864 2.658L16.8 8.991l-2.302 2.302-8.634-8.635z"/>
            </svg>
            Google Play
          </motion.a>

          {/* Note */}
          <p className="text-gray-400 text-xs">
            {t('autoRedirect', 'Redirection automatique sur mobile')}
          </p>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}

export default InvitePage;
